export const inspectTable = [
  {
    content: "1. 적격수급인 선정 의무",
    isChecked: "",
  },
  {
    content: "2. 안전보건총괄책임자 지정",
    isChecked: "",
  },
  {
    content: "3. 도급인의 안전 및 보건조치",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 안전보건협의체 구성 및 운영",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 작업장 순회점검",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 작업장 합동점검",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 안전보건 교육 지원 및 실시 확인",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 경보체계 운영과 대피 방법 등 훈련",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 위생시설 설치 이용 협조",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 작업시기·내용, 안전보건조치 확인·조정",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 위험성평가 실시",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 안전보건관리규정 작성",
    isChecked: "",
  },
  {
    title: "4. 도급에 따른 산업재해 예방 조치",
    content: "• 작업환경 측정",
    isChecked: "",
  },
  {
    content: "5. 안전보건에 관한 정보제공 등",
    isChecked: "",
  },
  {
    content: "6. 도급인의 수급인에 대한 시정조치",
    isChecked: "",
  },
  {
    content: "7. 종사자 의견 청취",
    isChecked: "",
  },
  {
    content: "8. 안전보건 확보 의무 이행점검",
    isChecked: "",
  },
];
